
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import moment from 'moment';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const RefundsAndCancellations = () => {
    const [loader, setLoader] = useState(false)
    const [cmsDetails, setCmsDetails] = useState({});

    useEffect(() => {
        setLoader(true)
        cmsDetailsAction({ slug: "refund-cancellation" }, (response) => {
            if (response?.status === true) {
                setCmsDetails(response?.data)
            }
            setLoader(false)
        })();
    }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    Cancellation and Refund Policy
                    {/* {cmsDetails.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails?.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}
                    <div className="cms_content_text">
                        <p>
                            At Millionaire11, we believe in maintaining transparency and fairness in all our operations, including transactions. This Cancellation and Refund Policy outlines the terms under which users may request refunds and the conditions where cancellation may occur, in line with RBI guidelines and the operational practices of payment gateways, banks, and digital wallet services.
                        </p>
                        <br />

                        <p>
                            Users may voluntarily cancel their participation in any contest until the official contest deadline (generally the match start time) by removing their team or exiting from the contest. Once the deadline has passed, entries are locked in, and no cancellation or refund can be made, even if the user’s team does not score any points or is disqualified due to technical issues or ineligibility.
                        </p>
                        
                        <br />
                        
                        <p>
                            In the rare case of a contest being cancelled by the company due to unavoidable reasons (such as match cancellation, incorrect data feed, or system errors), the entry fee will be refunded to the user’s wallet balance. This amount can be used for future contests but is not directly withdrawable unless specifically credited as a withdrawable bonus or as per TDS eligibility.
                        </p>

                        <br />

                        <p>
                            Deposits made into your Millionaire11 wallet are non-refundable. No cancellation of payments once processed will be entertained, and the company shall not be responsible for any transaction made erroneously to the wrong account or wallet. However, in cases of failed or duplicate transactions, users are advised to contact customer support within 24 hours along with appropriate screenshots or transaction proof. All such cases will be verified by our finance and payment gateway partners before any reversal is initiated. Refunds, if applicable, will be processed within 7–14 working days to the original mode of payment, depending on the policies of banks or wallet providers.
                        </p>

                        <br />

                        <p>
                            In case of suspected fraud, illegal activity, or breach of fair play, the company reserves the right to cancel any transaction, withhold funds, or initiate an investigation. If any deposit is found to have originated from a suspicious or unauthorized source, Millionaire11 may report the matter to the concerned legal authorities or payment partners. 
                        </p>

                        <br />
                        
                        <p>
                            All withdrawals are subject to successful KYC verification, PAN submission, and may be processed only to bank accounts or wallets registered under the user’s name. Once a withdrawal request is processed, it cannot be reversed. 
                        </p>

                        <br/>

                        <p>
                            This policy complies with Indian contract law, the Consumer Protection Act, the Reserve Bank of India (RBI) regulations, and Google Play Store and Apple App Store transaction policies. Any misuse or manipulation of payment systems will result in permanent suspension of the account and possible legal action.
                        </p>

                        <br/>

                        <p>
                            For any refund or transaction-related queries, please reach out to our Help & Support team for resolution.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RefundsAndCancellations